export const icons = {
    'application/pdf': 'https://www.wkkf.org/-/media/images/resource-directory/pdf-placeholder.png?mw=500',
    'application/word': 'https://www.wkkf.org/-/media/images/resource-directory/pdf-placeholder.png?mw=500',
    'application/excel': 'https://www.wkkf.org/-/media/images/resource-directory/pdf-placeholder.png?mw=500',
    'text/html': 'https://www.wkkf.org/-/media/images/resource-directory/pdf-placeholder.png?mw=500',
};
export const icon = (name) => {
    return icons[name] || 'https://cdn4.iconfinder.com/data/icons/48-bubbles/48/12.File-256.png';
};
export const whiteKidIcons = {
    mountain: '/img/icons/white/aardrijkskunde-kids_wit.svg',
    biology: '/img/icons/white/biologie-kids_wit.svg',
    desktop: '/img/icons/white/digitaal-kids_wit.svg',
    economy: '/img/icons/white/economie-kids_wit.svg',
    history: '/img/icons/white/geschiedenis-kids_wit.svg',
    art: '/img/icons/white/kunst-kids_wit.svg',
    read: '/img/icons/white/lezen-kids_wit.svg',
    motorSkills: '/img/icons/white/motoriek-kids_wit.svg',
    physics: '/img/icons/white/natuurkunde-kids_wit.svg',
    others: '/img/icons/white/overig-kids_wit.svg',
    person: '/img/icons/white/persoon-kids_wit.svg',
    calculus: '/img/icons/white/rekenen-kids_wit.svg',
    chemistry: '/img/icons/white/scheikunde-kids_wit.svg',
    social: '/img/icons/white/sociaal-kids_wit.svg',
    language: '/img/icons/white/taal-kids_wit.svg',
    foreignLanguage: '/img/icons/white/vreemdetalen-kids_wit.svg',
    world: '/img/icons/white/wereld-kids_wit.svg',
    independent: '/img/icons/white/zelfstandig-kids_wit.svg',
};
export const blackKidIcons = {
    mountain: '/img/icons/black/aardrijkskunde-kids.svg',
    biology: '/img/icons/black/biologie-kids.svg',
    desktop: '/img/icons/black/digitaal-kids.svg',
    economy: '/img/icons/black/economie-kids.svg',
    history: '/img/icons/black/geschiedenis-kids.svg',
    art: '/img/icons/black/kunst-kids.svg',
    read: '/img/icons/black/lezen-kids.svg',
    motorSkills: '/img/icons/black/motoriek-kids.svg',
    physics: '/img/icons/black/natuurkunde-kids.svg',
    others: '/img/icons/black/overig-kids.svg',
    person: '/img/icons/black/persoon-kids.svg',
    calculus: '/img/icons/black/rekenen-kids.svg',
    chemistry: '/img/icons/black/scheikunde-kids.svg',
    social: '/img/icons/black/sociaal-kids.svg',
    language: '/img/icons/black/taal-kids.svg',
    foreignLanguage: '/img/icons/black/vreemdetalen-kids.svg',
    world: '/img/icons/black/wereld-kids.svg',
    independent: '/img/icons/black/zelfstandig-kids.svg',
};
export const whiteAreaIcons = {
    mountain: '/img/icons/white/aardrijkskunde_wit.svg',
    biology: '/img/icons/white/biologie_wit.svg',
    desktop: '/img/icons/white/digitaal_wit.svg',
    economy: '/img/icons/white/economie_wit.svg',
    history: '/img/icons/white/geschiedenis_wit.svg',
    art: '/img/icons/white/kunst_wit.svg',
    read: '/img/icons/white/lezen_wit.svg',
    motorSkills: '/img/icons/white/motoriek_wit.svg',
    physics: '/img/icons/white/natuurkunde_wit.svg',
    others: '/img/icons/white/overig_wit.svg',
    person: '/img/icons/white/persoon_wit.svg',
    calculus: '/img/icons/white/rekenen_wit.svg',
    chemistry: '/img/icons/white/scheikunde_wit.svg',
    social: '/img/icons/white/sociaal_wit.svg',
    language: '/img/icons/white/taal_wit.svg',
    foreignLanguage: '/img/icons/white/vreemdetalen_wit.svg',
    world: '/img/icons/white/wereld_wit.svg',
    independent: '/img/icons/white/zelfstandig_wit.svg',
};
export const blackAreaIcons = {
    mountain: '/img/icons/black/aardrijkskunde.svg',
    biology: '/img/icons/black/biologie.svg',
    desktop: '/img/icons/black/digitaal.svg',
    economy: '/img/icons/black/economie.svg',
    history: '/img/icons/black/geschiedenis.svg',
    art: '/img/icons/black/kunst.svg',
    read: '/img/icons/black/lezen.svg',
    motorSkills: '/img/icons/black/motoriek.svg',
    physics: '/img/icons/black/natuurkunde.svg',
    others: '/img/icons/black/overig.svg',
    person: '/img/icons/black/persoon.svg',
    calculus: '/img/icons/black/rekenen.svg',
    chemistry: '/img/icons/black/scheikunde.svg',
    social: '/img/icons/black/sociaal.svg',
    language: '/img/icons/black/taal.svg',
    foreignLanguage: '/img/icons/black/vreemdetalen.svg',
    world: '/img/icons/black/wereld.svg',
    independent: '/img/icons/black/zelfstandig.svg',
};
export const fileIcons = {
    'application/vnd.ms-excel': '/img/icons/files/excel.svg',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '/img/icons/files/excel.svg',
    'application/pdf': '/img/icons/files/pdf.svg',
    'application/msword': '/img/icons/files/word.svg',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '/img/icons/files/word.svg',
    'application/vnd.ms-powerpoint': '/img/icons/files/powerpoint.svg',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': '/img/icons/files/powerpoint.svg',
    'other': '/img/icons/files/file.svg',
};
export const lessonTypeIcons = {
    test: 'ballot',
    instruction: 'import_contacts',
    guided: 'supervisor_account',
    group: 'group',
    individual: 'face',
};
